var AuthMessages = {
    "homepage": "Homepage",
    "signIn": "Sign in",
    "forgotYourPassword": "Forgot your password?",
    "resetPassword": "Reset password",
    "enterYourPassword": "Enter your password.",
    "mustContainAtLeastCharacters": "Must contain at least {min} character(s).",
    "canContainAtMostCharacters": "Can contain at most {max} characters.",
    "passwordStrength.weak": "Weak",
    "passwordStrength.ok": "Okay",
    "passwordStrength.good": "Good",
    "passwordStrength.strong": "Strong",
    "passwordsMustBeTheSame": "Your passwords must be the same.",
    "reset": "Reset",
    "setPassword": "Set password",
    "couldNotResetPassword": "Could not save your password. Your reset-URL might be expired or invalid.",
    "password": "Password",
    "repeatPassword": "Repeat password",
    "save": "Save",
    "invalidEmailOrPassword": "Invalid e-mail address and/or password.",
    "somethingWentWrong": "Something went wrong",
    "error": "Error!",
    "or": "Or",
    "visitOurHomepage": "visit our homepage",
    "signInAfterResetError": "Your password was reset but couldn't sign in. Please try again or contact us.",
    "2FaCode": "2FA code",
    "enter6DigitCode": "Enter your 6-digit code",
    "2FaCodeVerification": "2FA code verification",
    "2FaCodeVerification.description": "Enter the 6-digit code generated by your authenticator app to complete the login process. If you have lost access to your codes, please <a>contact our support team</a> for assistance.",
    "codeMustBe6Digits": "Code must be 6 digits.",
    "invalid2FaCode": "Invalid 2FA code.",
    "2faCodeEntryExpired": "2FA Code Entry Expired",
    "2faCodeEntryExpired.description": "The time to enter your 2FA code has expired. Please sign in again. You have 15 minutes to enter your 2FA code again.",
    "close": "Close",
    "entered2FaCodeWrong": "Invalid 2FA code. Please enter a valid 6-digit code or request a new one if the code has expired.",
    "emailAddress": "E-mail address",
    "enterEmailAddress": "Enter your e-mail address.",
    "emailAddress.placeholder": "Email@address.com",
    "cancel": "Cancel",
    "continue": "Continue",
};
export default AuthMessages;
